import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/userContext";
const ProtectRoute = (props) => {
  let { user, userData } = useUserContext();
  let navigator = useNavigate();

  useEffect(() => {
    if (!user?.id) {
      navigator("/login");
    }
  }, [user]);
  useEffect(() => {

    if (userData && !userData.account.is_read_policy) {
      navigator("account/policy");
    }
  }, [userData]);

  return <Outlet {...props} />;
};

export default ProtectRoute;
